const Users = () => {
  return (
    <div className="fade-in">
      <h1 style={{ color: 'var(--text-primary)', marginBottom: '2rem' }}>
        👥 User Management
      </h1>
      <div style={{
        background: 'var(--bg-card)',
        border: '1px solid var(--border-color)',
        borderRadius: '16px',
        padding: '3rem',
        textAlign: 'center'
      }}>
        <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🚧</div>
        <h2 style={{ color: 'var(--text-primary)', marginBottom: '1rem' }}>
          User Management Coming Soon
        </h2>
        <p style={{ color: 'var(--text-secondary)' }}>
          Manage customer accounts and user data here.
        </p>
      </div>
    </div>
  )
}

export default Users
